import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "password-expiry-gate"
};
const _hoisted_2 = {
  class: "card password-expiry-gate__card"
};
const _hoisted_3 = {
  class: "card-body p-4"
};
const _hoisted_4 = {
  class: "card-title mb-2"
};
const _hoisted_5 = {
  class: "text-muted mb-1"
};
const _hoisted_6 = {
  class: "text-muted small mb-4"
};
const _hoisted_7 = {
  class: "mb-3"
};
const _hoisted_8 = {
  class: "form-label",
  for: "expiry-current"
};
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-block"
};
const _hoisted_10 = {
  class: "mb-3"
};
const _hoisted_11 = {
  class: "form-label",
  for: "expiry-new"
};
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback d-block"
};
const _hoisted_13 = {
  class: "mb-4"
};
const _hoisted_14 = {
  class: "form-label",
  for: "expiry-confirm"
};
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback d-block"
};
const _hoisted_16 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_17 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h4", _hoisted_4, _toDisplayString($options.wording.title), 1), _createElementVNode("p", _hoisted_5, _toDisplayString($options.wording.lead), 1), _createElementVNode("p", _hoisted_6, _toDisplayString($options.wording.rules), 1), _createElementVNode("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.submit && $options.submit(...args), ["prevent"]))
  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", _hoisted_8, _toDisplayString($options.wording.current), 1), _withDirectives(_createElementVNode("input", {
    id: "expiry-current",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.password = $event),
    class: _normalizeClass([{
      'border-danger': !!_ctx.errors.password
    }, "form-control"]),
    autocomplete: "current-password",
    type: "password"
  }, null, 2), [[_vModelText, $data.form.password]]), _ctx.errors.password ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errors.password), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("label", _hoisted_11, _toDisplayString($options.wording.new), 1), _withDirectives(_createElementVNode("input", {
    id: "expiry-new",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.new = $event),
    class: _normalizeClass([{
      'border-danger': !!_ctx.errors.new
    }, "form-control"]),
    autocomplete: "new-password",
    type: "password"
  }, null, 2), [[_vModelText, $data.form.new]]), _ctx.errors.new ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.errors.new), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, _toDisplayString($options.wording.confirm), 1), _withDirectives(_createElementVNode("input", {
    id: "expiry-confirm",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.new_confirmation = $event),
    class: _normalizeClass([{
      'border-danger': !!_ctx.errors.new_confirmation
    }, "form-control"]),
    autocomplete: "new-password",
    type: "password"
  }, null, 2), [[_vModelText, $data.form.new_confirmation]]), _ctx.errors.new_confirmation ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.errors.new_confirmation), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
    class: "btn btn-link px-0",
    type: "button",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.logout && $options.logout(...args))
  }, _toDisplayString($options.wording.logout), 1), _createElementVNode("button", {
    disabled: $data.saving,
    class: "btn btn-primary",
    type: "submit"
  }, _toDisplayString($options.wording.submit), 9, _hoisted_17)])], 32)])])])) : _createCommentVNode("", true);
}